import {commitMutation, graphql} from 'react-relay';
import type {Environment, Disposable} from 'relay-runtime';
import {csrfToken, socketClientId} from '../../../forecast-app/ticketing/graphql/forecastRelay';
import type {useUpdateAccountMutation, UpdateAccountInput} from './__generated__/useUpdateAccountMutation.graphql';

const mutation = graphql`
	mutation useUpdateAccountMutation($input: UpdateAccountInput!) {
		updateAccount(input: $input) {
			clientMutationId
			account {
				id
				autoCloseDays
				inboundLocalPart
				supportEmailDomainConfigured
				slug
				ticketNumberNext
				responseSlaValue
				responseSlaUnit
				resolutionSlaValue
				resolutionSlaUnit
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: UpdateAccountInput,
	onCompleted?: (r: useUpdateAccountMutation['response']) => void,
	onError?: (e: Error) => void
): Disposable {
	return commitMutation<useUpdateAccountMutation>(environment, {
		mutation,
		variables: {
			input: {csrfToken: csrfToken(), socketClientId: socketClientId(), ...input},
		},
		onCompleted: onCompleted ? response => onCompleted(response) : undefined,
		onError: onError ? error => onError(error) : undefined,
	});
}

export default {commit, mutationId: 'useUpdateAccountMutation'};
